/**
 * Created by rkotha on 8/21/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('UserHomePageController', UserHomePageController);

    UserHomePageController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'contactEntities','announcementsEntities', 'NasracWebContent'];

    function UserHomePageController ($scope, Principal, LoginService, $state, $sce, contactEntities, announcementsEntities,NasracWebContent) {
        //var vm = this;

        var contactsEntity = contactEntities[0];
        var announcementEntity = announcementsEntities[0];
        $scope.contactsTrustedHtml = $sce.trustAsHtml(contactsEntity.content);
        $scope.announcementsTrustedHtml = $sce.trustAsHtml(announcementEntity.content);

    }
})();
